// // version: 1.0.0
// /* eslint-disable react/no-unescaped-entities */
// /* eslint-disable @typescript-eslint/no-misused-promises */
// /* eslint-disable @typescript-eslint/restrict-template-expressions */
// /* eslint-disable @typescript-eslint/no-floating-promises */
// /* eslint-disable @typescript-eslint/explicit-function-return-type */
// /* eslint-disable @typescript-eslint/strict-boolean-expressions */
// /* PAGE: UserPage
//    ========================================================================== */
// import React, { useState, useEffect, useRef, useCallback } from 'react'
// import { NavLink, useLocation, useNavigate } from 'react-router-dom'

// import SidebarLinkGroup from '../../../components/SidebarLinkGroup'
// import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'

// import { getFromLocalStorage, removeLocalStorage } from 'utils/functions'
// import CryptoJS from 'crypto-js'

// import ROUTES from 'routes/constant'

// import { useTranslation } from 'react-i18next'

// interface SidebarProps {
//   sidebarOpen: boolean
//   setSidebarOpen: (open: boolean) => void
// }

// const Sidebar: React.FC<SidebarProps> = ({ sidebarOpen, setSidebarOpen }) => {
//   const navigate = useNavigate()
//   const { t } = useTranslation()

//   const [tokens, setTokens] = useState(getFromLocalStorage<any>('tokens'))
//   useEffect(() => {
//     const handleStorageChange = () => {
//       setTokens(getFromLocalStorage<any>('tokens'))
//     }
//     window.addEventListener('storage', handleStorageChange)
//     return () => {
//       window.removeEventListener('storage', handleStorageChange)
//     }
//   }, [])
//   const userRole = tokens?.key
//   const userLastName = tokens?.lastName
//   const userFirstName = tokens?.firstName
//   const userEmail = tokens?.email

//   let data: string | undefined
//   if (userRole) {
//     try {
//       const giaiMa = CryptoJS.AES.decrypt(userRole, 'Access_Token_Secret_#$%_ExpressJS_Authentication')
//       data = giaiMa.toString(CryptoJS.enc.Utf8)
//     } catch (error) {
//       console.error('Decryption error:', error)
//     }
//   }

//   const location = useLocation()
//   const { pathname } = location

//   const sidebar = useRef<HTMLDivElement>(null)
//   const trigger = useRef<HTMLButtonElement>(null)

//   const storedSidebarExpanded = localStorage.getItem('sidebar-expanded')
//   const [sidebarExpanded, setSidebarExpanded] = useState(storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true')

//   // close on click outside
//   useEffect(() => {
//     const clickHandler = ({ target }: { target: EventTarget | null }) => {
//       if (!sidebar.current || !trigger.current) return
//       if (!sidebarOpen || sidebar.current.contains(target as Node) || trigger.current.contains(target as Node)) return
//       setSidebarOpen(false)
//     }
//     document.addEventListener('click', clickHandler)
//     return () => document.removeEventListener('click', clickHandler)
//   })

//   // close if the esc key is pressed
//   useEffect(() => {
//     const keyHandler = ({ keyCode }: { keyCode: number }) => {
//       if (!sidebarOpen || keyCode !== 27) return
//       setSidebarOpen(false)
//     }
//     document.addEventListener('keydown', keyHandler)
//     return () => document.removeEventListener('keydown', keyHandler)
//   })

//   useEffect(() => {
//     localStorage.setItem('sidebar-expanded', sidebarExpanded.toString())
//     if (sidebarExpanded) {
//       document.querySelector('body')?.classList.add('sidebar-expanded')
//     } else {
//       document.querySelector('body')?.classList.remove('sidebar-expanded')
//     }
//   }, [sidebarExpanded])

//   const handleLogout = useCallback(async () => {
//     removeLocalStorage('tokens')
//     navigate(ROUTES.login)
//   }, [navigate])

//   return (
//     <div>
//       {/* Sidebar backdrop (mobile only) */}
//       <div
//         className={`fixed inset-0 bg-slate-900 bg-opacity-30 z-40 lg:hidden lg:z-auto transition-opacity duration-200 ${sidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
//           }`}
//         aria-hidden="true"
//       ></div>

//       {/* Sidebar */}
//    <div
//         id="sidebar"
//         ref={sidebar}
//         className={`flex flex-col absolute z-40 left-0 top-0 lg:static lg:left-auto lg:top-auto lg:translate-x-0 h-screen overflow-y-scroll lg:overflow-y-auto no-scrollbar overflow-x-hidden w-64 lg:w-20 lg:sidebar-expanded:!w-64 2xl:!w-64 shrink-0 bg-sky-300 shadow-right p-4 transition-all duration-200 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-64'
//           }`}
//       >
//         {/* Sidebar header */}
//         <div className="flex justify-between mb-10 pr-3 sm:px-2">
//           {/* Close button */}
//           <button
//             ref={trigger}
//             className="lg:hidden text-slate-500 hover:text-slate-400"
//             onClick={() => setSidebarOpen(!sidebarOpen)}
//             aria-controls="sidebar"
//             aria-expanded={sidebarOpen}
//           >
//             <span className="sr-only">Close sidebar</span>
//             <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//               <path d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z" />
//             </svg>
//           </button>
//           {/* Logo */}
//           <NavLink end to="/" className="block">
//             <svg width="32" height="32" viewBox="0 0 32 32">
//               <defs>
//                 <linearGradient x1="28.538%" y1="20.229%" x2="100%" y2="108.156%" id="logo-a">
//                   <stop stopColor="#A5B4FC" stopOpacity="0" offset="0%" />
//                   <stop stopColor="#A5B4FC" offset="100%" />
//                 </linearGradient>
//                 <linearGradient x1="88.638%" y1="29.267%" x2="22.42%" y2="100%" id="logo-b">
//                   <stop stopColor="#38BDF8" stopOpacity="0" offset="0%" />
//                   <stop stopColor="#38BDF8" offset="100%" />
//                 </linearGradient>
//               </defs>
//               <rect fill="#6366F1" width="32" height="32" rx="16" />
//               <path d="M18.277.16C26.035 1.267 32 7.938 32 16c0 8.837-7.163 16-16 16a15.937 15.937 0 01-10.426-3.863L18.277.161z" fill="#4F46E5" />
//               <path
//                 d="M7.404 2.503l18.339 26.19A15.93 15.93 0 0116 32C7.163 32 0 24.837 0 16 0 10.327 2.952 5.344 7.404 2.503z"
//                 fill="url(#logo-a)"
//               />
//               <path
//                 d="M2.223 24.14L29.777 7.86A15.926 15.926 0 0132 16c0 8.837-7.163 16-16 16-5.864 0-10.991-3.154-13.777-7.86z"
//                 fill="url(#logo-b)"
//               />
//             </svg>
//           </NavLink>
//         </div>

//         {/* Links */}
//         <div className="space-y-8">
//           {/* Pages group */}
//           <div>
//             <div>
//               <div className="flex items-center">
//                 <div className="flex-shrink-0">
//                   {/* <img className="rounded-full object-cover w-10 h-10" src={Image} alt="User upload" /> */}
//                 </div>
//                 <div className="w-36 ml-4 flex flex-col justify-center lg:hidden lg:sidebar-expanded:block 2xl:block">
//                   <p className='font-semibold text-base overflow-hidden overflow-ellipsis whitespace-nowrap'>
//                     {`${userFirstName || ''} ${userLastName || ''}`}
//                   </p>
//                   <p className='text-gray-500 text-xs overflow-hidden overflow-ellipsis whitespace-nowrap'>{userEmail}</p>
//                 </div>
//               </div>
//               <div className=" ml-1 text-gray-500 text-base font-mono">
//                 <p>{data}</p>
//               </div>
//             </div>
//             <h3 className="text-xs uppercase text-slate-500 font-semibold pl-3 mt-3">
//               <span className="hidden lg:block lg:sidebar-expanded:hidden 2xl:hidden text-center w-6" aria-hidden="true">
//                 •••
//               </span>
//               <span className="lg:hidden lg:sidebar-expanded:block 2xl:block">{t('sidebar.pages')}</span>
//             </h3>
//             <ul className="mt-3">
//               {/* Permissions */}
//               <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${pathname.includes('permission') && 'bg-teal-300 text-blue-500'}`}>
//                 <NavLink
//                   end
//                   to="/permission"
//                   className={`block ${pathname.includes('permission') ? 'text-white' : 'text-gray-500'} hover:text-neutral-400 truncate transition duration-150 ${pathname.includes('permission') && 'hover:text-slate-200'}`}
//                   onClick={() => {
//                     setSidebarOpen(false)
//                   }}
//                 >
//                   <div className="flex items-center">
//                     <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
//                       <path className={`fill-current text-slate-600 ${pathname.includes('permission') && 'text-white'}`} d="M1 3h22v20H1z" />
//                       <path
//                         className={`fill-current text-slate-400 ${pathname.includes('permission') && 'text-teal-500'}`}
//                         d="M21 3h2v4H1V3h2V1h4v2h10V1h4v2Z"
//                       />
//                     </svg>
//                     <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
//                       {t('sidebar.permissions')}
//                     </span>
//                   </div>
//                 </NavLink>
//               </li>
//               {/* users */}
//               <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${pathname.includes('user') && 'bg-teal-300 text-blue-500'}`}>
//                 <NavLink
//                   end
//                   to="/user"
//                   className={`block ${pathname.includes('user') ? 'text-white' : 'text-gray-500'} hover:text-neutral-400 truncate transition duration-150 ${pathname.includes('user') && 'hover:text-slate-200'}`}
//                   onClick={() => {
//                     setSidebarOpen(false)
//                   }}
//                 >
//                   <div className="flex items-center">
//                     <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
//                       <path
//                         className={`fill-current text-slate-600 ${pathname.includes('user') && 'text-indigo-500'}`}
//                         d="M20 7a.75.75 0 01-.75-.75 1.5 1.5 0 00-1.5-1.5.75.75 0 110-1.5 1.5 1.5 0 001.5-1.5.75.75 0 111.5 0 1.5 1.5 0 001.5 1.5.75.75 0 110 1.5 1.5 1.5 0 00-1.5 1.5A.75.75 0 0120 7zM4 23a.75.75 0 01-.75-.75 1.5 1.5 0 00-1.5-1.5.75.75 0 110-1.5 1.5 1.5 0 001.5-1.5.75.75 0 111.5 0 1.5 1.5 0 001.5 1.5.75.75 0 110 1.5 1.5 1.5 0 00-1.5 1.5A.75.75 0 014 23z"
//                       />
//                       <path
//                         className={`fill-current text-slate-400 ${pathname.includes('user') && 'text-white'}`}
//                         d="M17 23a1 1 0 01-1-1 4 4 0 00-4-4 1 1 0 010-2 4 4 0 004-4 1 1 0 012 0 4 4 0 004 4 1 1 0 010 2 4 4 0 00-4 4 1 1 0 01-1 1zM7 13a1 1 0 01-1-1 4 4 0 00-4-4 1 1 0 110-2 4 4 0 004-4 1 1 0 112 0 4 4 0 004 4 1 1 0 010 2 4 4 0 00-4 4 1 1 0 01-1 1z"
//                       />
//                     </svg>
//                     <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
//                       {t('sidebar.users')}
//                     </span>
//                   </div>
//                 </NavLink>
//               </li>
//               {/* dashboard */}
//               <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${pathname.includes('dashboard') && 'bg-teal-300 text-blue-500'}`}>
//                 <NavLink
//                   end
//                   to="/dashboard/enrollment_dashboard"
//                   className={`block ${pathname.includes('dashboard') ? 'text-white' : 'text-gray-500'} hover:text-neutral-400 truncate transition duration-150 ${pathname.includes('dashboard') && 'hover:text-slate-200'}`}
//                   onClick={() => {
//                     setSidebarOpen(false)
//                   }}
//                 >
//                   <div className="flex items-center">
//                     <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
//                       <path
//                         className={`fill-current text-slate-400 ${pathname.includes('dashboard') && 'text-indigo-300'}`}
//                         d="M13 15l11-7L11.504.136a1 1 0 00-1.019.007L0 7l13 8z"
//                       />
//                       <path
//                         className={`fill-current text-slate-700 ${pathname.includes('dashboard') && '!text-white'}`}
//                         d="M13 15L0 7v9c0 .355.189.685.496.864L13 24v-9z"
//                       />
//                       <path
//                         className={`fill-current text-slate-600 ${pathname.includes('dashboard') && 'text-white'}`}
//                         d="M13 15.047V24l10.573-7.181A.999.999 0 0024 16V8l-11 7.047z"
//                       />
//                     </svg>
//                     <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
//                       {t('sidebar.dashboard')}
//                     </span>
//                   </div>
//                 </NavLink>
//               </li>
//               {/* Settings */}
//               <SidebarLinkGroup activecondition={pathname.includes('settings')}>
//                 {(handleClick, open) => {
//                   return (
//                     <React.Fragment>
//                       <a
//                         href="#0"
//                         className={`block ${pathname.includes('settings') ? 'text-white' : 'text-gray-500'} hover:text-neutral-400 truncate transition duration-150 ${pathname.includes('settings') && 'hover:text-slate-200'}`}
//                         onClick={(e) => {
//                           e.preventDefault()
//                           sidebarExpanded ? handleClick() : setSidebarExpanded(true)
//                         }}
//                       >
//                         <div className="flex items-center justify-between">
//                           <div className="flex items-center">
//                             <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
//                               <path
//                                 className={`fill-current text-slate-600 ${pathname.includes('settings') && 'text-indigo-500'}`}
//                                 d="M19.714 14.7l-7.007 7.007-1.414-1.414 7.007-7.007c-.195-.4-.298-.84-.3-1.286a3 3 0 113 3 2.969 2.969 0 01-1.286-.3z"
//                               />
//                               <path
//                                 className={`fill-current text-slate-400 ${pathname.includes('settings') && 'text-indigo-300'}`}
//                                 d="M10.714 18.3c.4-.195.84-.298 1.286-.3a3 3 0 11-3 3c.002-.446.105-.885.3-1.286l-6.007-6.007 1.414-1.414 6.007 6.007z"
//                               />
//                               <path
//                                 className={`fill-current text-slate-600 ${pathname.includes('settings') && 'text-indigo-500'}`}
//                                 d="M5.7 10.714c.195.4.298.84.3 1.286a3 3 0 11-3-3c.446.002.885.105 1.286.3l7.007-7.007 1.414 1.414L5.7 10.714z"
//                               />
//                               <path
//                                 className={`fill-current text-slate-400 ${pathname.includes('settings') && 'text-indigo-300'}`}
//                                 d="M19.707 9.292a3.012 3.012 0 00-1.415 1.415L13.286 5.7c-.4.195-.84.298-1.286.3a3 3 0 113-3 2.969 2.969 0 01-.3 1.286l5.007 5.006z"
//                               />
//                             </svg>
//                             <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
//                               {t('sidebar.settings')}
//                             </span>
//                           </div>
//                           {/* Icon */}
//                           <div className="flex shrink-0 ml-2">
//                             <svg
//                               className={`w-3 h-3 shrink-0 ml-1 fill-current text-slate-400 ${open && 'rotate-180'}`}
//                               viewBox="0 0 12 12"
//                             >
//                               <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
//                             </svg>
//                           </div>
//                         </div>
//                       </a>
//                       <div className="lg:hidden lg:sidebar-expanded:block 2xl:block">
//                         <ul className={`pl-9 mt-1 ${!open && 'hidden'}`}>
//                           <li className="mb-1 last:mb-0">
//                             <NavLink
//                               end
//                               to="/settings/profile"
//                               className={({ isActive }) =>
//                                 'block text-balack hover:text-slate-200 transition duration-150 truncate ' + (isActive ? '!text-teal-500' : '')
//                               }
//                               onClick={() => {
//                                 setSidebarOpen(false)
//                               }}
//                             >
//                               <span className="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
//                                 {t('sidebar.myAccount')}
//                               </span>
//                             </NavLink>
//                           </li>
//                         </ul>
//                       </div>
//                     </React.Fragment>
//                   )
//                 }}
//               </SidebarLinkGroup>
//               {/* lesson */}
//               <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${pathname.includes('lesson') && 'bg-teal-300 text-blue-500'}`}>
//                 <NavLink
//                   end
//                   to="/lesson"
//                   className={`block ${pathname.includes('lesson') ? 'text-white' : 'text-gray-500'} hover:text-neutral-400 truncate transition duration-150 ${pathname.includes('lesson') && 'hover:text-slate-200'}`}
//                   onClick={() => {
//                     setSidebarOpen(false)
//                   }}
//                 >
//                   <div className="flex items-center">
//                     <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
//                       <path d="M4 19V6.2C4 5.0799 4 4.51984 4.21799 4.09202C4.40973 3.71569 4.71569 3.40973 5.09202 3.21799C5.51984 3 6.0799 3 7.2 3H16.8C17.9201 3 18.4802 3 18.908 3.21799C19.2843 3.40973 19.5903 3.71569 19.782 4.09202C20 4.51984 20 5.0799 20 6.2V17H6C4.89543 17 4 17.8954 4 19ZM4 19C4 20.1046 4.89543 21 6 21H20M9 7H15M9 11H15M19 17V21" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                     </svg>
//                     <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
//                       {t('lesson.lesson')}
//                     </span>
//                   </div>
//                 </NavLink>
//               </li>
//               <hr className="bg-slate-200 my-5" />
//               {/* Log out */}
//               <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${pathname.includes('logout') && 'bg-teal-300 text-blue-500'}`}>
//                 <NavLink
//                   end
//                   to="/login"
//                   onClick={handleLogout}
//                   className={`block ${pathname.includes('logout') ? 'text-white' : 'text-gray-500'} hover:text-neutral-400 truncate transition duration-150 ${pathname.includes('logout') && 'hover:text-slate-200'}`}
//                 >
//                   <div className="flex items-center">
//                     <LogoutOutlinedIcon />
//                     <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
//                       {t('sidebar.logOut')}
//                     </span>
//                   </div>
//                 </NavLink>
//               </li>
//             </ul>
//           </div>
//         </div>

//         {/* Expand / collapse button */}
//         <div className="pt-3 hidden lg:flex 2xl:hidden justify-end mt-auto">
//           <div className="px-3 py-2">
//             <button onClick={() => setSidebarExpanded(!sidebarExpanded)}>
//               <span className="sr-only">Expand / collapse sidebar</span>
//               <svg className="w-6 h-6 fill-current sidebar-expanded:rotate-180 transition-transform duration-200 ease-in-out" viewBox="0 0 24 24"> {/* Added transition-transform classes */}
//                 <path className="text-slate-400" d="M19.586 11l-5-5L16 4.586 23.414 12 16 19.414 14.586 18l5-5H7v-2z" />
//                 <path className="text-slate-600" d="M3 23H1V1h2z" />
//               </svg>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Sidebar

// version: 2.0.0
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* PAGE: UserPage
   ========================================================================== */
import React, { useEffect, useRef } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import SidebarLinkGroup from '../../../components/SidebarLinkGroup'

interface SidebarProps {
  sidebarOpen: boolean
  setSidebarOpen: (open: boolean) => void
  sidebarExpanded: boolean // Add this
  setSidebarExpanded: (expanded: boolean) => void // Add this
}

const Sidebar: React.FC<SidebarProps> = ({ sidebarOpen, setSidebarOpen, sidebarExpanded, setSidebarExpanded }) => { // Add props
  const location = useLocation()
  const { pathname } = location

  const sidebar = useRef<HTMLDivElement>(null)
  const trigger = useRef<HTMLButtonElement>(null)

  // Remove local sidebarExpanded state, it's now a prop
  // const storedSidebarExpanded = localStorage.getItem('sidebar-expanded')
  // const [sidebarExpanded, setSidebarExpanded] = useState(storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true')

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }: { target: EventTarget | null }) => {
      if (!sidebar.current || !trigger.current) return
      // For mobile, if sidebar is open and click is outside sidebar AND outside the header's toggle button
      // We need a way to identify the header's toggle button or make this logic simpler.
      // For now, this only considers clicks outside the sidebar itself.
      if (!sidebarOpen || sidebar.current.contains(target as Node) || trigger.current.contains(target as Node)) return
      setSidebarOpen(false)
    }
    document.addEventListener('click', clickHandler)
    return () => document.removeEventListener('click', clickHandler)
  })

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }: { keyCode: number }) => {
      if (!sidebarOpen || keyCode !== 27) return
      setSidebarOpen(false)
    }
    document.addEventListener('keydown', keyHandler)
    return () => document.removeEventListener('keydown', keyHandler)
  })

  useEffect(() => {
    // Use the sidebarExpanded prop
    localStorage.setItem('sidebar-expanded', sidebarExpanded.toString())
    if (sidebarExpanded) {
      document.querySelector('body')?.classList.add('sidebar-expanded')
    } else {
      document.querySelector('body')?.classList.remove('sidebar-expanded')
    }
  }, [sidebarExpanded]) // Depend on the prop

  return (
    <div>
      {/* Sidebar backdrop (mobile only) */}
      <div
        className={`fixed inset-x-0 bottom-0 top-16 bg-slate-900 bg-opacity-30 z-40 lg:hidden lg:z-auto transition-opacity duration-200 ${sidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`} // Changed inset-0 to inset-x-0 bottom-0 top-16
        aria-hidden="true"
      ></div>

      {/* Sidebar */}
      <div
        id="sidebar"
        ref={sidebar}
        className={`flex flex-col fixed z-50 left-0 top-16 lg:static lg:left-auto lg:top-auto lg:translate-x-0 h-full overflow-y-scroll lg:overflow-y-auto no-scrollbar overflow-x-hidden w-64 lg:w-20 lg:sidebar-expanded:!w-64 shrink-0 bg-gradient-to-b from-sky-200 via-rose-200 to-amber-200 shadow-right p-4 transition-all duration-200 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-64'
          }`} // Changed z-40 to z-50, and top-0 to top-16
      >
        {/* Links */}
        <div className="space-y-8">
          {/* Pages group */}
          <div>
            <ul className="mt-3">
              {/* Thông tin giáo xứ */}
              <SidebarLinkGroup activecondition={pathname.includes('parish-information')}>
                {(handleClick, open) => {
                  return (
                    <React.Fragment>
                      <a
                        href="#0"
                        className={`block ${pathname.includes('parish-information') ? 'text-white' : 'text-gray-500'} hover:text-neutral-400 truncate transition duration-150 ${pathname.includes('parish-information') && 'hover:text-slate-200'}`}
                        onClick={(e) => {
                          e.preventDefault()
                          // Use sidebarExpanded prop and setSidebarExpanded prop
                          sidebarExpanded ? handleClick() : setSidebarExpanded(true)
                        }}
                      >
                        {/* ... content of a tag ... */}
                        <div className="flex items-center justify-between">
                          <div className="flex items-center">
                            <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                              <path
                                className={`fill-current text-slate-600 ${pathname.includes('parish-information') && 'text-indigo-500'}`}
                                d="M19.714 14.7l-7.007 7.007-1.414-1.414 7.007-7.007c-.195-.4-.298-.84-.3-1.286a3 3 0 113 3 2.969 2.969 0 01-1.286-.3z"
                              />
                              <path
                                className={`fill-current text-slate-400 ${pathname.includes('parish-information') && 'text-indigo-300'}`}
                                d="M10.714 18.3c.4-.195.84-.298 1.286-.3a3 3 0 11-3 3c.002-.446.105-.885.3-1.286l-6.007-6.007 1.414-1.414 6.007 6.007z"
                              />
                              <path
                                className={`fill-current text-slate-600 ${pathname.includes('parish-information') && 'text-indigo-500'}`}
                                d="M5.7 10.714c.195.4.298.84.3 1.286a3 3 0 11-3-3c.446.002.885.105 1.286.3l7.007-7.007 1.414 1.414L5.7 10.714z"
                              />
                              <path
                                className={`fill-current text-slate-400 ${pathname.includes('parish-information') && 'text-indigo-300'}`}
                                d="M19.707 9.292a3.012 3.012 0 00-1.415 1.415L13.286 5.7c-.4.195-.84.298-1.286.3a3 3 0 113-3 2.969 2.969 0 01-.3 1.286l5.007 5.006z"
                              />
                            </svg>
                            <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                               Thông tin giáo xứ
                            </span>
                          </div>
                          {/* Icon */}
                          <div className="flex shrink-0 ml-2">
                            <svg
                              className={`w-3 h-3 shrink-0 ml-1 fill-current text-slate-400 ${open && 'rotate-180'}`}
                              viewBox="0 0 12 12"
                            >
                              <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                            </svg>
                          </div>
                        </div>
                      </a>
                      {/* Links for Thông tin giáo xứ */}
                      <div className="lg:hidden lg:sidebar-expanded:block 2xl:block">
                        <ul className={`pl-9 mt-1 ${!open && 'hidden'}`}>
                          <li className="mb-1 last:mb-0">
                            <NavLink
                              end
                              to="/parish-information/parish"
                              className={({ isActive }) =>
                                'block text-slate-400 hover:text-slate-200 transition duration-150 truncate ' + (isActive ? '!text-indigo-500' : '')
                              }
                              onClick={() => {
                                setSidebarOpen(false)
                              }}
                            >
                              <span className="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Giáo xứ
                              </span>
                            </NavLink>
                          </li>
                          <li className="mb-1 last:mb-0">
                            <NavLink
                              end
                              to="/parish-information/sub-parish"
                              className={({ isActive }) =>
                                'block text-slate-400 hover:text-slate-200 transition duration-150 truncate ' + (isActive ? '!text-indigo-500' : '')
                              }
                              onClick={() => {
                                setSidebarOpen(false)
                              }}
                            >
                              <span className="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Danh sách giáo họ
                              </span>
                            </NavLink>
                          </li>
                          <li className="mb-1 last:mb-0">
                            <NavLink
                              end
                              to="/parish-information/priest"
                              className={({ isActive }) =>
                                'block text-slate-400 hover:text-slate-200 transition duration-150 truncate ' + (isActive ? '!text-indigo-500' : '')
                              }
                              onClick={() => {
                                setSidebarOpen(false)
                              }}
                            >
                              <span className="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Danh sách linh mục
                              </span>
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                    </React.Fragment>
                  )
                }}
              </SidebarLinkGroup>
              {/* Giáo dân và Gia đình */}
              <SidebarLinkGroup activecondition={pathname.includes('community-management')}>
                {(handleClick, open) => {
                  return (
                    <React.Fragment>
                      <a
                        href="#0"
                        className={`block ${pathname.includes('community-management') ? 'text-white' : 'text-gray-500'} hover:text-neutral-400 truncate transition duration-150 ${pathname.includes('community-management') && 'hover:text-slate-200'}`}
                        onClick={(e) => {
                          e.preventDefault()
                          // Use sidebarExpanded prop and setSidebarExpanded prop
                          sidebarExpanded ? handleClick() : setSidebarExpanded(true)
                        }}
                      >
                        {/* ... content of a tag ... */}
                        <div className="flex items-center justify-between">
                          <div className="flex items-center">
                            <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                              <path
                                className={`fill-current text-slate-600 ${pathname.includes('community-management') && 'text-indigo-500'}`}
                                d="M19.714 14.7l-7.007 7.007-1.414-1.414 7.007-7.007c-.195-.4-.298-.84-.3-1.286a3 3 0 113 3 2.969 2.969 0 01-1.286-.3z"
                              />
                              <path
                                className={`fill-current text-slate-400 ${pathname.includes('community-management') && 'text-indigo-300'}`}
                                d="M10.714 18.3c.4-.195.84-.298 1.286-.3a3 3 0 11-3 3c.002-.446.105-.885.3-1.286l-6.007-6.007 1.414-1.414 6.007 6.007z"
                              />
                              <path
                                className={`fill-current text-slate-600 ${pathname.includes('community-management') && 'text-indigo-500'}`}
                                d="M5.7 10.714c.195.4.298.84.3 1.286a3 3 0 11-3-3c.446.002.885.105 1.286.3l7.007-7.007 1.414 1.414L5.7 10.714z"
                              />
                              <path
                                className={`fill-current text-slate-400 ${pathname.includes('community-management') && 'text-indigo-300'}`}
                                d="M19.707 9.292a3.012 3.012 0 00-1.415 1.415L13.286 5.7c-.4.195-.84.298-1.286.3a3 3 0 113-3 2.969 2.969 0 01-.3 1.286l5.007 5.006z"
                              />
                            </svg>
                            <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                               Giáo dân và Gia đình
                            </span>
                          </div>
                          {/* Icon */}
                          <div className="flex shrink-0 ml-2">
                            <svg
                              className={`w-3 h-3 shrink-0 ml-1 fill-current text-slate-400 ${open && 'rotate-180'}`}
                              viewBox="0 0 12 12"
                            >
                              <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                            </svg>
                          </div>
                        </div>
                      </a>
                      {/* Links for Giáo dân và Gia đình */}
                      <div className="lg:hidden lg:sidebar-expanded:block 2xl:block">
                        <ul className={`pl-9 mt-1 ${!open && 'hidden'}`}>
                          <li className="mb-1 last:mb-0">
                            <NavLink
                              end
                              to="/community-management/parishioner"
                              className={({ isActive }) =>
                                'block text-slate-400 hover:text-slate-200 transition duration-150 truncate ' + (isActive ? '!text-indigo-500' : '')
                              }
                              onClick={() => {
                                setSidebarOpen(false)
                              }}
                            >
                              <span className="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Danh sách giáo dân
                              </span>
                            </NavLink>
                          </li>
                          <li className="mb-1 last:mb-0">
                            <NavLink
                              end
                              to="/community-management/family"
                              className={({ isActive }) =>
                                'block text-slate-400 hover:text-slate-200 transition duration-150 truncate ' + (isActive ? '!text-indigo-500' : '')
                              }
                              onClick={() => {
                                setSidebarOpen(false)
                              }}
                            >
                              <span className="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Danh sách gia đình
                              </span>
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                    </React.Fragment>
                  )
                }}
              </SidebarLinkGroup>
              <hr className="bg-slate-200 my-5" />
            </ul>
          </div>
        </div>

        {/* REMOVE Expand / collapse button */}
        {/* <div className="pt-3 hidden lg:flex 2xl:hidden justify-end mt-auto">
          <div className="px-3 py-2">
            <button onClick={() => setSidebarExpanded(!sidebarExpanded)}>
              <span className="sr-only">Expand / collapse sidebar</span>
              <svg className="w-6 h-6 fill-current sidebar-expanded:rotate-180 transition-transform duration-200 ease-in-out" viewBox="0 0 24 24">
                <path className="text-slate-400" d="M19.586 11l-5-5L16 4.586 23.414 12 16 19.414 14.586 18l5-5H7v-2z" />
                <path className="text-slate-600" d="M3 23H1V1h2z" />
              </svg>
            </button>
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default Sidebar
